import { appConfig, pad } from "../../../utils";

export const addIsi = ({ form, store, db }) => {
    const nextRevision = 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setConfig({
        "title": "Add Information Security Risk",
        "type": "push",
        "location": "SafetyManagement/InformationSecurityRisks",
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${appConfig.docPrefix}ISI-${pad(store.state.counts.isi.count)}`;
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async preSubmitHook({ db }) {
            const number = await db.utils.allocateCount("counts/isi/count");
            return {
                "Number": `${appConfig.docPrefix}ISI-${pad(number)}`,
            };
        },
        async postSubmitHook({ files, typeRef }) {
            for (const file of files) {
                await db.upload(`Database/InformationSecurityRisks/${typeRef.key}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/InformationSecurityRisks/${typeRef.key}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "By": store.state.user.Basic.name,
                    "Date": new Date().toISOString(),
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const editIsi = ({ form, pageItem, db }) => {
    form.setValues(pageItem);
    form.setConfig({
        "title": "Edit Information Security Risk",
        "type": "update",
        "location": `SafetyManagement/InformationSecurityRisks/${pageItem.ID}`,
        "fields": [{
            "label": "Title",
            "name": "Title",
            "type": "text",
            "required": true
        }]
    });
    form.toggle();
};

export const reviseIsi = ({ form, pageItem, store, db }) => {
    const nextRevision = parseInt(pageItem.Revision) + 1;
    const nextRevisionID = `--${pad(nextRevision, 2)}`;

    form.setValues(pageItem);
    form.setConfig({
        "title": "Revise Information Security Risk",
        "type": "update",
        "location": `SafetyManagement/InformationSecurityRisks/${pageItem.ID}`,
        "fields": [{
            "label": "Next Revision",
            "type": "value",
            value() {
                return nextRevision;
            }
        }, {
            "label": "File",
            "name": "File",
            "type": "file",
            "required": true
        }],
        async postSubmitHook({ files }) {
            for (const file of files) {
                await db.upload(`Database/InformationSecurityRisks/${pageItem.ID}/Revisions/${nextRevisionID}`, file[0]);
            }

            await db.update(`SafetyManagement/InformationSecurityRisks/${pageItem.ID}/`, {
                "Revision": nextRevision,
                "RevisionID": nextRevisionID,
                [`Revisions/${nextRevisionID}`]: {
                    "Revision": nextRevision,
                    "Date": new Date().toISOString(),
                    "By": store.state.user.Basic.name,
                    "ID": nextRevisionID,
                    "File": files[0][0].name,
                }
            });

            return;
        }
    });
    form.toggle();
};

export const uploadFile = reviseIsi;
